import React, { PropTypes } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';

export default class DetailsBox extends React.Component {

	prettifyArray(arr) {
		const names = [];
		arr.map((e) => names.push(e.name));
		return names.join(", ");
	}

	createLink(url) {
		const prefix = url.indexOf("http://") === -1 && url.indexOf("https://") === -1 ? 'http://' : '';
		return <a target="_blank" href={prefix + url}>{prefix + url}</a>;
	}

	formatDate(date) {
		return moment(date).format("DD/MM/YYYY");
	}

	create(title, content, formatter) {
		return (
			<div style={{marginTop: "10px"}}>
				<div className="details-title">
					{title}
				</div>
				<div className="details-content">
					{formatter(content)}
				</div>
			</div>
		);
	}
	
	render () {		
		const { title, authors, institutions, keywords, themes, url,
			datetime, startCoverageDate, endCoverageDate, isPublic, description, folder } = this.props.details;			
		if ( isEmpty(this.props.details) ) return null;
		return (			
			<div>
				<div style={{marginTop: "10px"}}>
					<div className="details-title">
						Título
					</div>
					<div className="details-content">
						{title}
					</div>
				</div>
				{folder !== null ? this.create("Pasta", folder.name, (x) => x) : null}
				{authors.length > 0 ? this.create("Autores", authors, this.prettifyArray) : null}
				{institutions.length > 0 ? this.create("Instituições", institutions, this.prettifyArray) : null}
				{url !== "" && typeof url !== "undefined" && url !== null
					? this.create("Link para o Documento", url, this.createLink) 
					: null}
				{themes.length > 0 ? this.create("Temas", themes, this.prettifyArray) : null}
				{keywords.length > 0 ? this.create("Palavras-Chave", keywords, this.prettifyArray) : null}
				{datetime !== null ? this.create("Data da Última Modificação", datetime, this.formatDate) : null}
				{startCoverageDate !== null 
					? this.create("Início da Cobertura Temporal", startCoverageDate, this.formatDate) 
					: null}
				{endCoverageDate !== null 
					? this.create("Fim da Cobertura Temporal", endCoverageDate, this.formatDate) 
					: null}
				{description !== "" ? this.create("Descrição", description, (e) => e) : null}						
				{this.create("Visibilidade", isPublic, (c) => c ? "Todos os Grupos" : "Apenas Meu Grupo")}	
			</div>		
		);
	}
}

DetailsBox.propTypes = {
	details: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/DetailsContent.js